export var performanceNow = function performanceNow() {
  return performance.now();
};